import React, { FC } from 'react'
import { ChipLabelProps } from './ChipLabel.model'

export const ChipLabel: FC<ChipLabelProps> = ({ label, sublabel, title = label }) => (
  <>
    <span className="max-w-fit text-[12px] hover:scale-[1.02] font-medium 	" title={title}>
      {label}
    </span>
    {sublabel && (
      <span className="chip-sublabel " title={sublabel}>
        {sublabel}
      </span>
    )}
  </>
)
